import {images} from "../Rolls/imagesRolls";
import {imagesSets} from "../Sets/imagesSets";
import {imageSalads} from "../Salads/imageSalads";


export const PopularNow = [
    {
        id:93 ,
        categoria: '1',
        img: images.filadelfiaClassic,
        title: 'Филадельфия классик',
        structure: 'НОРИ, РИС, ЛОСОСЬ, ОГУРЕЦ.',
        price: '335',
        countRolls: '8',
        weight: '215',
        kCal: '263'
    },
    {
        id:38 ,
        img: imagesSets.semeinii,
        title: 'СЕМЕЙНЫЙ',
        structure: 'РОЛЛЫ: ЧИЗ ЛОСОСЬ 1, КАЛИФОРНИЯ КЛАССИК 1, ГРИН 1/2, ЭПЛ 1, ОГУРЕЦ 1, ЛОСОСЬ 1, КРАБ 1, ОКУНЬ 1, ГУД 1/2. СУШИ: УГОРЬ 1, ОКУНЬ 1, ЛОСОСЬ 1, КРЕВЕТКА 1.',
        price: '1495',
        count: '60',
        weight: '1438',
    },
    {
        id: 911,
        categoria: '2',
        img: images.american,
        title: 'АМЕРИКАНСКИЙ',
        structure: 'РИС,НОРИ,ОГУРЕЦ,НЕЖНЕЙШИЙ СЫР,МАСАГО,ЛОСОСЬ,УГОРЬ.',
        price: '410',
        countRolls: '8',
        weight: '265',
        kCal: '367'
    },
    {
        id: 920,
        categoria: '3',
        img: images.vulkan,
        title: 'ВУЛКАН',
        structure: 'РИС,НОРИ,БЛИН ТОМАГО,ЛОСОСЬ,ОГУРЕЦ,ЛУК ЗЕЛЕНЫЙ,СОУС СПАЙСИ,СОУС СВИТ ЧИЛИ',
        price: '275',
        countRolls: '8',
        weight: '275',
        kCal: '320'
    },
    {
        id:7,
        img: imageSalads.sarada,
        title: 'САРАДА',
        structure: 'САЛАТ АЙСБЕРГ,ОГУРЕЦ,УГОРЬ,ПЕРЕЦ БОЛГАРСКИЙ,СОУС ФИРМЕННЫЙ,КУНЖУТ.',
        price: '385',
        weight: '220',
    },

    {
        id: 920,
        categoria: '3',
        img: images.vulkan,
        title: 'ВУЛКАН',
        structure: 'РИС,НОРИ,БЛИН ТОМАГО,ЛОСОСЬ,ОГУРЕЦ,ЛУК ЗЕЛЕНЫЙ,СОУС СПАЙСИ,СОУС СВИТ ЧИЛИ',
        price: '275',
        countRolls: '8',
        weight: '275',
        kCal: '320'
    },
    {
        id:93 ,
        categoria: '1',
        img: images.filadelfiaClassic,
        title: 'Филадельфия классик',
        structure: 'НОРИ, РИС, ЛОСОСЬ, ОГУРЕЦ.',
        price: '335',
        countRolls: '8',
        weight: '215',
        kCal: '263'
    },
    {
        id:38 ,
        img: imagesSets.semeinii,
        title: 'СЕМЕЙНЫЙ',
        structure: 'РОЛЛЫ: ЧИЗ ЛОСОСЬ 1, КАЛИФОРНИЯ КЛАССИК 1, ГРИН 1/2, ЭПЛ 1, ОГУРЕЦ 1, ЛОСОСЬ 1, КРАБ 1, ОКУНЬ 1, ГУД 1/2. СУШИ: УГОРЬ 1, ОКУНЬ 1, ЛОСОСЬ 1, КРЕВЕТКА 1.',
        price: '1495',
        count: '60',
        weight: '1438',
    },
    {
        id: 911,
        categoria: '2',
        img: images.american,
        title: 'АМЕРИКАНСКИЙ',
        structure: 'РИС,НОРИ,ОГУРЕЦ,НЕЖНЕЙШИЙ СЫР,МАСАГО,ЛОСОСЬ,УГОРЬ.',
        price: '410',
        countRolls: '8',
        weight: '265',
        kCal: '367'
    },
    {
        id: 920,
        categoria: '3',
        img: images.vulkan,
        title: 'ВУЛКАН',
        structure: 'РИС,НОРИ,БЛИН ТОМАГО,ЛОСОСЬ,ОГУРЕЦ,ЛУК ЗЕЛЕНЫЙ,СОУС СПАЙСИ,СОУС СВИТ ЧИЛИ',
        price: '275',
        countRolls: '8',
        weight: '275',
        kCal: '320'
    },
    {
        id:7,
        img: imageSalads.sarada,
        title: 'САРАДА',
        structure: 'САЛАТ АЙСБЕРГ,ОГУРЕЦ,УГОРЬ,ПЕРЕЦ БОЛГАРСКИЙ,СОУС ФИРМЕННЫЙ,КУНЖУТ.',
        price: '385',
        weight: '220',
    },

    {
        id: 920,
        categoria: '3',
        img: images.vulkan,
        title: 'ВУЛКАН',
        structure: 'РИС,НОРИ,БЛИН ТОМАГО,ЛОСОСЬ,ОГУРЕЦ,ЛУК ЗЕЛЕНЫЙ,СОУС СПАЙСИ,СОУС СВИТ ЧИЛИ',
        price: '275',
        countRolls: '8',
        weight: '275',
        kCal: '320'
    },


]